/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Otp_Purpose_Sign_InInputs */

const th_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบ Remy Sport`)
};

const en_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sign in to Remy Sport`)
};

const ja_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport にログインする`)
};

const zh_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录 Remy Sport`)
};

const es_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iniciar sesión en Remy Sport`)
};

const pt_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrar no Remy Sport`)
};

const id_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masuk ke Remy Sport`)
};

const fr_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vous connecter à Remy Sport`)
};

const tl_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mag-sign in sa Remy Sport`)
};

const vi_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đăng nhập vào Remy Sport`)
};

const ko_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport에 로그인할`)
};

const de_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dich bei Remy Sport anmelden`)
};

const ru_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`войти в Remy Sport`)
};

const tr_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport'a giriş yapmak`)
};

const it_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`accedere a Remy Sport`)
};

const pl_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zalogować się do Remy Sport`)
};

const uk_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`увійти до Remy Sport`)
};

const hi_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport में साइन इन करने`)
};

const ar_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجّل الدخول إلى Remy Sport`)
};

const ms_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`log masuk ke Remy Sport`)
};

const bn_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport-এ সাইন ইন করার`)
};

const zh_tw2_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入 Remy Sport`)
};

const zh_hk2_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入 Remy Sport`)
};

const ur_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport میں سائن اِن کرنے`)
};

const fa_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ورود به Remy Sport`)
};

const sw_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kuingia kwenye Remy Sport`)
};

const nl_email_otp_purpose_sign_in = /** @type {(inputs: Email_Otp_Purpose_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in te loggen bij Remy Sport`)
};

/**
* | output |
* | --- |
* | "sign in to Remy Sport" |
*
* @param {Email_Otp_Purpose_Sign_InInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_otp_purpose_sign_in = /** @type {((inputs?: Email_Otp_Purpose_Sign_InInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Otp_Purpose_Sign_InInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_otp_purpose_sign_in(inputs)
	if (locale === "ja") return ja_email_otp_purpose_sign_in(inputs)
	if (locale === "zh") return zh_email_otp_purpose_sign_in(inputs)
	if (locale === "es") return es_email_otp_purpose_sign_in(inputs)
	if (locale === "pt") return pt_email_otp_purpose_sign_in(inputs)
	if (locale === "id") return id_email_otp_purpose_sign_in(inputs)
	if (locale === "fr") return fr_email_otp_purpose_sign_in(inputs)
	if (locale === "tl") return tl_email_otp_purpose_sign_in(inputs)
	if (locale === "vi") return vi_email_otp_purpose_sign_in(inputs)
	if (locale === "ko") return ko_email_otp_purpose_sign_in(inputs)
	if (locale === "de") return de_email_otp_purpose_sign_in(inputs)
	if (locale === "ru") return ru_email_otp_purpose_sign_in(inputs)
	if (locale === "tr") return tr_email_otp_purpose_sign_in(inputs)
	if (locale === "it") return it_email_otp_purpose_sign_in(inputs)
	if (locale === "pl") return pl_email_otp_purpose_sign_in(inputs)
	if (locale === "uk") return uk_email_otp_purpose_sign_in(inputs)
	if (locale === "hi") return hi_email_otp_purpose_sign_in(inputs)
	if (locale === "ar") return ar_email_otp_purpose_sign_in(inputs)
	if (locale === "ms") return ms_email_otp_purpose_sign_in(inputs)
	if (locale === "bn") return bn_email_otp_purpose_sign_in(inputs)
	if (locale === "zh-TW") return zh_tw2_email_otp_purpose_sign_in(inputs)
	if (locale === "zh-HK") return zh_hk2_email_otp_purpose_sign_in(inputs)
	if (locale === "ur") return ur_email_otp_purpose_sign_in(inputs)
	if (locale === "fa") return fa_email_otp_purpose_sign_in(inputs)
	if (locale === "sw") return sw_email_otp_purpose_sign_in(inputs)
	if (locale === "nl") return nl_email_otp_purpose_sign_in(inputs)
	return en_email_otp_purpose_sign_in(inputs)
});